import { ordinal } from "./ordinal.filter";
import { range } from "./range.filter";
import { thousandsSeparator } from "./format-number.filter";
import angular from "angular";
import { dateDiffFromNow, dateDiffFromNowColor, dateDiffFromNowConversational } from ".";
import { TitleCaseFilter } from "./title-case.filter";
import { bolder } from "./bolder.filter";
import { absolutePercentage } from "./absolute-percentage.filter";
import { booleanUpdateValue } from "./boolean-update-value.filter";
import { status } from "./status.filter";
import { ghIsNaN } from "./is-nan.filter";
import { trim } from "./trim.filter";
import { cut } from "./cut.filter";
import { jiraIssueLink } from "./jira-issue-link.filter";
import { objLength } from "./obj-length.filter";
import { metric } from "./metric.filter";
import { sessionStatus } from "./session-status.filter";
import { sessionCadenceType } from "./session-cadence-type.filter";
import { attainmentOperator } from "./attainment-operator.filter";

const mod = angular
  .module("sharedFilters", [])
  .filter("dateDiffFromNow", dateDiffFromNow)
  .filter("dateDiffFromNowColor", dateDiffFromNowColor)
  .filter("range", range)
  .filter("ordinal", ordinal)
  .filter("thousandsSeparator", thousandsSeparator)
  .filter("titleCase", TitleCaseFilter)
  .filter("dateDiffFromNowConversational", dateDiffFromNowConversational)
  .filter("bolder", bolder)
  .filter("absolutePercentage", absolutePercentage)
  .filter("booleanUpdateValue", booleanUpdateValue)
  .filter("status", status)
  .filter("isNaN", ghIsNaN)
  .filter("trim", trim)
  .filter("cut", cut)
  .filter("jiraIssueLink", jiraIssueLink)
  .filter("objLength", objLength)
  .filter("metric", metric)
  .filter("sessionStatus", sessionStatus)
  .filter("sessionCadenceType", sessionCadenceType)
  .filter("attainmentOperator", attainmentOperator);

export default mod.name;
